var map = {
	"./tianlian/icon.png": "5H+/",
	"./zhangmen/icon.png": "9WVk",
	"./zhetian/icon.png": "bk85"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ZYwT";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image ^\.\/.*\/icon\.png$
// module id = ZYwT
// module chunks = 5